/* ============
 * Users Settings  Mutations Types
 * ============
 *
 * The mutations available for the SettingsUsers  module.
 */

export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const SET_PAGINATION = 'SET_PAGINATION';

export default {
  SET_CURRENT_PAGE,
  SET_PAGINATION,
};



// WEBPACK FOOTER //
// ./src/store/modules/settings-groups/types.js